import React from 'react';
import { CreateAdCampaignInput } from 'types/ad-campaign';

import CreateAdCampaignView from 'views/Dashboard/ad-campaigns/CreateAdCampaignView';

type Props = {
  handleNext: () => void;
  setCreateAdCampaignData: React.Dispatch<React.SetStateAction<CreateAdCampaignInput | undefined>>;
};

export default ({
  handleNext, setCreateAdCampaignData,
}: Props) => {
  const onSimpleViewSubmit = (data: CreateAdCampaignInput) => {
    setCreateAdCampaignData(data);

    handleNext();
  };

  return (
    <CreateAdCampaignView onSimpleViewSubmit={onSimpleViewSubmit} />
  );
};
